var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#E8313A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.4667 24.6003L44.3 20.9335C44.1333 20.7668 43.9667 20.7668 43.9667 20.7668L18.4667 14.4333H17.8C17.1333 14.6 16.9667 15.2667 17.1333 15.9334L30.1333 51.7676C30.1333 51.9343 30.3 52.101 30.4667 52.2676C30.9667 52.601 31.6333 52.4343 31.8 52.101L49.8 26.4336C50.1333 25.767 49.9667 24.9336 49.4667 24.6003ZM35.9667 31.4338L43.9667 22.7669L47.6333 25.4336L35.9667 31.4338ZM19.9667 16.4334L33.3 32.2671L42.8 22.1002L19.9667 16.4334ZM33.8 34.1005L46.9667 27.267L32.3 48.2675L33.8 34.1005ZM32.4667 33.4338L19.4667 17.9334L30.8 49.1009L32.4667 33.4338Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrx);
export default __webpack_public_path__ + "static/media/TRX.d2e6e5d3de88a34d2d7ab57539a15715.svg";
export { ForwardRef as ReactComponent };